import { ModalBackground, ModalCard } from "../linktab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useRef, useState } from "react";
import file from "../../../assets/images/Image File.png";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { addproductlink } from "../../../validations/addproductlink";
import EditIcon from "../../../assets/images/Edit.svg";
import axios from "axios";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Heading, ImageContainer, Image, Input, Important, Edit } from "./styles";
interface PaymentProps {
  toggleClear: () => void;
  getLink: () => void;
  linkData: any;
}
type FormData = yup.InferType<typeof addproductlink>;
export function EditLinkModal({
  toggleClear,
  getLink,
  linkData,
}: PaymentProps) {
  const [isloading, setisloading] = useState(false);
  const imageRef = useRef<any>();
  const imageSubmitRef = useRef<any>();
  let businessUuid = useSelector((state: any) => state.auth.uuid);
  const [imageSize, setImageSize] = useState({
    message: "",
  });
  let [linkForm, setlinkForm] = useState<any>({});
  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(addproductlink),
    defaultValues: {
      name: linkData.name === "null" ? "" : linkData.name,
      url: linkData.url,
      important: linkData.isImportant,
    },
  });
  const { errors, isSubmitting, isDirty, isValid } = formState;

  const handleImage = (event: any) => {
    event.preventDefault();
    let formData = new FormData();
    if (linkForm?.image?.name) {
      formData.append("image", linkForm.image, linkForm.image?.name);
    }
    if (linkForm?.image === null) {
      setImageSize({
        message: "Image required ",
      });
    } else if (linkForm?.image?.size >= 5000000) {
      setImageSize({
        message: "File is too large, Max allowed size is 5MB",
      });
    } else {
      setImageSize({
        message: "",
      });
      formData.append("businessUuid", businessUuid);

      axios
        .post(`${API_URL}/update/link/image/${linkData.id}`, formData)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            toast.success(response.data.message);
            toggleClear();
            getLink();
          }
        })
        .catch((error) => {
          setisloading(false);
          if (
            error?.response?.status === 400 ||
            error?.response?.status === 401
          ) {
            toast.error(error?.response?.data?.message);
            return;
          }
          toast.error("Connection Failed");
        });
    }
    // setTimeout(getLatestProfile, 4000);
  };

  const previewImage = (event: any) => {
    event.preventDefault();
    let reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        imageRef.current.src = reader.result;
        setlinkForm({ ...linkForm, image: event.target.files[0] });
        setTimeout(() => {
          imageSubmitRef.current.click();
        }, 500);
      }
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const createProductRequest = (data: any) => {
    setisloading(true);
    let url = null;
    const testUrl = /https?:\/\//i.test(data.url); // Check for "http" or "https"

    if (testUrl) {
      url = data.url;
    } else {
      url = `https://${data.url}`;
    }

    let formData = {
      id: linkData.id,
      name: data.name === "" || data.name === null ? null : data.name,
      url: url,
      isImportant: data.important,
    };

    axios
      .post(`${API_URL}/update/link`, formData)
      .then((response) => {
        reset();
        setlinkForm({ name: null, image: null, price: null });
        if (response.status === 200 || response.status === 201) {
          setisloading(false);
          toast.success(response.data.message);
          toggleClear();
          setlinkForm({});
          getLink();
        }
      })
      .catch((error) => {
        setisloading(false);
        setlinkForm({});

        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };
  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>Edit Link</Heading>
          <form
            onSubmit={handleImage}
            // hidden={true}
          >
            <ImageContainer>
              <Image>
                <Edit>
                  <img src={EditIcon} alt=""  />
                </Edit>

                <img src={linkData?.image || linkForm?.image?.imageUrl || file} alt="" ref={imageRef} />
                <input
                  className="h-[100%] w-[100%] opacity-0  cursor-pointer absolute top-0 left-0 z-50 "
                  type="file"
                  {...register("fileUpload")}
                  onChange={previewImage}
                  accept="image/*"
                />
                <input type="submit" value="save image" ref={imageSubmitRef} hidden={true} />
              </Image>
            </ImageContainer>
            {imageSize?.message && <p className="text-xs mb-2 text-red-600">{imageSize?.message}</p>}
          </form>
          <form onSubmit={handleSubmit(createProductRequest)}>
            <Input type="text" placeholder={"Name"} {...register("name")} />
            {errors?.name && <p className="text-xs mb-2 text-red-600">{errors.name?.message}</p>}
            <Input type="text" placeholder={"Link"} {...register("url")} />
            {errors?.url && <p className="text-xs mb-2 text-red-600">{errors.url?.message}</p>}
            <Important>
              <p>Tag as Important</p>
              <input type="checkbox" id="check" {...register("important")} />
              <label htmlFor="check" className="button"></label>
            </Important>
            <SubmitButton
              isDisabled={isSubmitting || !isDirty || !isValid}
              isloading={isloading}
              value="Save"
              width="19.6em"
            />
          </form>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}
